<template>
  <div class="animated fadeIn usuario-perfil">
    <b-card header='Perfil'>
      <b-form>
        <b-row>
          <b-col class="avatar" cols="12" xl="12">
            <figure>
              <img
                @click.prevent="updateAvatar"
                :src="userAvatar"
                class="img-avatar"
                :alt="nombre"/>
            </figure>
            <!-- <b-form-file v-model="avatarFile" 
              class="mt-3" 
              accept=".jpg, .png, .jpeg" 
              placeholder=""
              plain></b-form-file> -->
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Apellido"
              label-for="apellido"
              :label-cols="labelCols">
              <b-form-input 
                id="apellido"
                v-model.trim= "$v.apellido.$model" 
                :state="apellidoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="apellidoFeedback">
                {{ apellidoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols">
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols">
              <b-form-input 
                id="email"
                v-model.trim= "$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-modal ref="avatarModal"
        title="Seleccione la imagen"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <avatar
        @close="closeAvatarModal">
      </avatar>  
    </b-modal>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Avatar from  './Avatar.vue';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarioperfil/getField',
  mutationType: 'usuarioperfil/updateField',
});

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    Mensaje,
    Avatar
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      noValidar: true,
      nombreValido: null,
      apellidoValido: null,
      emailValido: null,
      nombreInvalidoMsj: '',
      apellidoInvalidoMsj: '',
      emailInvalidoMsj: '',

      labelCols: 1,
      // avatarFile: '',
      avatarEnabled: true,
    }
  },
  computed: {
    ...mapFields([
      'apellido',
      'nombre',
      'email',
      'avatar',
      'avatarExtension'
    ]),
    userAvatar: function () {
      let server = process.env.VUE_APP_ROOT_API;
      let avatar = server + '/img/avatars/man.png';
      
      if (this.avatar) {
        if (this.avatar != '') {
          avatar = `data:image/${this.avatarExtension};base64,${this.avatar}`;
        }
      }
      
      return avatar;
    }
  },  
  created() {
    let usuarioId = 0;

    if (this.$store.getters['user/loggedIn']) {
      usuarioId = parseInt(this.$store.getters['user/userId']) ;
    }

    // this.avatarEnabled = usuarioId == 1 ? true : false;
    
    this.$store.dispatch('usuarioperfil/inicializar', usuarioId);
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "apellido" || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido del usuario';
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El apellido del usuario sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del usuario';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre del usuario sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == "email" || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false;
          if (!this.$v.email.required) {
            this.emailInvalidoMsj = 'Debe ingresar el email del usuario';
          } else if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser válido.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('usuarioperfil/save')
          .then(() => {
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = 'Los cambios se registraron con éxito.';
            this.modalVariant = 'light';
            this.modalMsj = true;
          })
          .catch( error => {
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = error;
            this.modalVariant = 'danger';
            this.modalMsj = true;
          })
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.modalRegistroExitoso = false
      this.$router.go(-1);
    },
    updateAvatar() {
      if (this.avatarEnabled) {
        this.$refs.avatarModal.show();
      }
    },
    closeAvatarModal() {
      this.$refs.avatarModal.hide();
    }
    // updateAvatar() {
    //   let params = {
    //     file: this.avatarFile
    //   }
    //   this.showSpinner();
    //   this.$store.dispatch('usuarioperfil/updateAvatar', params)
    //     .catch( error => {
    //       this.modalOkAction = null;
    //       this.modalHiddenAction = null;
    //       this.modalMensaje = error;
    //       this.modalVariant = 'danger';
    //       this.modalMsj = true;
    //     })
    //     .finally(() => this.hideSpinner());
    // }
  },
  watch: {
    // avatarFile (newVal, oldVal) {
    //   if (newVal) {
    //     this.updateAvatar();
    //   }
    // }    
  },
  validations: {
    apellido: {
      required,
      maxLength: maxLength(150)
    },
    nombre: {
      required,
      maxLength: maxLength(150)
    },
    email: {
      required,
      email,
      maxLength: maxLength(150)
    },
  },  
}
</script>

<style>
  .usuario-perfil .avatar {
    width: 100%;
    min-height: 100px;
    /* border: 1px solid red; */
    text-align: center;
    margin-bottom: 20px;
  }
  .usuario-perfil img.img-avatar {
    max-width: 120px !important;
    height: auto;
  }
  .usuario-perfil img.img-avatar:hover {
    cursor: pointer;
  }
</style>
